module.exports = __webpack_public_path__ + "static/media/travel10.010cd709.jpg";